module.exports = __webpack_public_path__ + "static/media/variable_intro3-cy.c93cef77.svg";